import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'next/router';
import { inject, observer } from 'mobx-react';
import withCustomComponent from 'ui/components/withCustomComponent';
import { LessonPageCommentsListItem } from './LessonPageCommentsListItem';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

export const LessonPageCommentsList = withCustomComponent(
  'LessonPageCommentsList'
)(
  inject(
    'appStore',
    'coursesStore'
  )(
    withRouter(
      observer(({ router, appStore, coursesStore }) => {
        const lesson = coursesStore.lessonPage.Lesson;

        return (
          <>
            {lesson.Comments.length > 0 &&
              <ul className="list-unstyled mb-0">
                <TransitionGroup className="comments-list">
                  {lesson.Comments.map((comment, i) => (
                    <CSSTransition
                      key={comment.Id}
                      timeout={200}
                      classNames="comment"
                    >
                      <li className="mb-8">
                        <LessonPageCommentsListItem comment={comment} />
                      </li>
                    </CSSTransition>
                  ))}
                </TransitionGroup>
              </ul>
            }
          </>
        );
      })
    )
  )
);
